export enum ItemType {
  coin = 'coin',
  oemSubscription = 'subscription',
  artistSubscription = 'artist_subscription',
  digitalContent = 'digital_content',
}

export type CoinDetail = {
  detail: {
    ios: number;
    android: number;
    web: number;
  };
  availableCoin: number;
};

export type CoinMenuList = {
  normal: Array<CoinMenu>;
};

export type CoinMenu = {
  id: number;
  name: string;
  description: string;
  productId: string;
  taxIncludedPrice: number;
  coin: number;
  publishedAt: string;
  closedAt: string;
};

export type CoinHistoryItem = {
  id: number;
  userId: number;
  type: string;
  subType: string;
  usedCoin: number;
  oemServiceId: number;
  oemServiceName: string;
  oemServiceBranchId: number;
  oemServiceBranchName: string;
  platform: string;
  customInfo: CustomInfoItem;
  createdAt: string;
  updatedAt: string;
};

export type CoinHistoryList = {
  data: Array<CoinHistoryItem>;
  currentPage: number;
  lastPage: number;
  total: number;
  perPage: number;
};

type CustomInfoItem = {
  lotteryEventId: number;
  lotteryEventName: string;
  lotteryPositions: Array<LotteryPositionItem>;
  lotteryPositionLinks: Array<LotteryPositionLink>;
  point: number;
  bonusPoint: number;
  percentage: number;
};

type LotteryPositionItem = {
  id: number;
  name: string;
};

type LotteryPositionLink = {
  name: string;
  link: string;
};

export type SerialCodeHistoryList = {
  data: Array<SerialCodeHistoryItem>;
  currentPage: number;
  lastPage: number;
  total: number;
  perPage: number;
};

export type SerialCodeHistoryItem = {
  id: number;
  serialCode: string;
  lotteryEventBranchId: number;
  lotteryEventBranchName: string;
  lotteryPrizeGoodsId: number;
  lotteryDrawHistoryId: number;
  isWon: boolean;
  usedAt: string;
};
